import React from 'react';

import { useAnalytics } from './analytics';
import { useConfigContext } from './config';
import { KalturaPlayer } from './KalturaPlayer';

export const useAppInitEffect = () => {
  const { getKalturaPlayerInitParams } = useConfigContext();
  const { init } = useAnalytics();

  React.useEffect(() => {
    init();
    KalturaPlayer.init(getKalturaPlayerInitParams());
  }, [init, getKalturaPlayerInitParams]);

  return null;
};
